import { useContext, useEffect, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Dialog,
  Button,
  TextField,
  Typography,
  DialogContent,
  FormHelperText,
} from "@mui/material";
//Import from project
import "../../../Style/dialogstyle.scss";
import moment from "moment";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import {
  SelectStudentByClass,
  SelectSubjectByClassId,
  SelectPerformanceType,
} from "../../Include/DynamicSelect/DynamicSelect";
import { DialogTitleComp } from "../../../Utils/Component";
// import MultilineSelectStudent from "../../Include/MultipleSelect/MultipleSelect";
import {
  CREATE_PERFORMANCE,
  UPDATE_PERFORMANCE,
} from "../../../Schema/Performance";
// import SelectTimePicker from "../../../Utils/SelectTimePicker";
// import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";

export default function PerformanceForm({
  open,
  classId,
  editData,
  setRefetch,
  dialogTitle,
  handleClose,
}) {
  // Change Language
  const { t, setAlert, language } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // const [selectedStudents, setSelectedStudents] = useState([]);
  const [studentVal, setStudentVal] = useState({
    id: "",
    title: "",
    // avatar: "",
  });

  const [createPerformance] = useMutation(CREATE_PERFORMANCE, {
    onCompleted: ({ createPerformance }) => {
      setLoading(false);

      if (createPerformance?.isSuccess === true) {
        setAlert(true, "success", createPerformance?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createPerformance?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updatePerformance] = useMutation(UPDATE_PERFORMANCE, {
    onCompleted: ({ updatePerformance }) => {
      setLoading(false);

      if (updatePerformance?.isSuccess === true) {
        setAlert(true, "success", updatePerformance?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updatePerformance?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    date: Yup.string().required(t("required")),
    description: Yup.string().required(t("required")),
    performanceTypeId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
    subjectId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      performanceTypeId: { id: "", title: "" },
      subjectId: { id: "", title: "" },
      description: "",
      date: moment(),
      remark: "",
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Update") {
        updatePerformance({
          variables: {
            id: editData?._id,
            input: {
              classId: classId,
              performanceTypeId: values?.performanceTypeId?.id,
              studentId: studentVal?.id,
              subjectId: values?.subjectId?.id,
              // date: moment(values?.date).format("YYYY-MM-DD"),
              description: values?.description,
              remark: values?.remark,
            },
          },
        });
      } else {
        createPerformance({
          variables: {
            input: {
              classId: classId || null,
              performanceTypeId: values?.performanceTypeId?.id,
              studentId: studentVal?.id,
              // date: moment(values?.date).format("YYYY-MM-DD"),
              subjectId: values?.subjectId?.id || null,
              description: values?.description,
              remark: values?.remark,
            },
          },
        });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  // console.log("editData:::", editData);

  useEffect(() => {
    if (dialogTitle === "Update" && editData) {
      setFieldValue("subjectId", {
        id: editData?.subjectId?._id,
        title:
          language == "en"
            ? editData?.subjectId?.enName
            : editData?.subjectId?.khName,
      });
      setFieldValue("performanceTypeId", {
        id: editData?.performanceTypeId?._id,
        title:
          language == "en"
            ? editData?.performanceTypeId?.enName
            : editData?.performanceTypeId?.khName,
      });
      setFieldValue("date", moment(editData?.date));
      setFieldValue("remark", editData?.remark);
      setFieldValue("description", editData?.description);
      setStudentVal({
        id: editData?.studentId?._id,
        title:
          editData?.studentId?.familyName +
          " " +
          editData?.studentId?.studentName,
      });
    }

    // if (dialogTitle === "Create" && open) {
    //   resetForm();
    // }
  }, [open, editData]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm" fullWidth>
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_performance")
            : t("modal_title_update_performance")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_student")}
                </Typography>
                <SelectStudentByClass
                  onChange={setStudentVal}
                  value={studentVal}
                  classId={classId}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_subject")}
                </Typography>
                <SelectSubjectByClassId
                  classId={classId}
                  value={values?.subjectId}
                  onChange={(val) => setFieldValue("subjectId", val)}
                />
                {!!errors.subjectId?.id && touched.subjectId?.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.subjectId?.id}
                  </FormHelperText>
                )}  
              </Grid>

              <Grid item xs={6}>
                <SelectPerformanceType
                  value={values?.performanceTypeId}
                  onChange={(val) => setFieldValue("performanceTypeId", val)}
                />
                {!!errors.performanceTypeId?.id && touched.performanceTypeId?.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.performanceTypeId?.id}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_description")}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={6}
                  size="small"
                  className="text-field"
                  placeholder={t("thead_description")}
                  {...getFieldProps("description")}
                  error={Boolean(touched.description && errors.description)}
                  helperText={touched.description && errors.description}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  rows={2}
                  fullWidth
                  multiline
                  size="small"
                  className="text-field"
                  placeholder={t("label_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    className={t("class-btn-create")}
                  >
                    {dialogTitle === "Update" ? t("update") : t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
